import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const HomePage = () => import('../views/HomePage')
const ShopPage = () => import('../views/Shop')

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '/',
      component: HomePage
    },
    {
      // 3. 添加 shop 路由
      path: '/shop',
      name: 'Shop', // 可选：给路由起个名字，方便在代码中引用
      component: ShopPage
    }
  ]
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js